<script lang="ts">
import { type PropType, defineComponent } from 'vue'

import type { HeaderBanner } from './HeaderBannerBaseCard.vue'
import HeaderBannerBaseCard from './HeaderBannerBaseCard.vue'

/**
 * HeaderBannerImageCard component displays a banner for the "image" variant.
 *
 * Constraints:
 * - fixed (var(--header-banner-static-section-width, 179px)) left section
 * - image on the right expanding width
 * - no subtext
 */
export default defineComponent({
  components: {
    HeaderBannerBaseCard,
  },
  props: {
    banner: {
      type: Object as PropType<HeaderBanner>,
      required: true,
      validator(value: HeaderBanner) {
        if (value.variant !== 'image') {
          console.warn(
            `Incorrect variant "${value.variant}" in HeaderBannerImageCard`,
            this
          )
          return false
        }

        if (value.subtext) {
          console.warn(
            `subtext cannot be set when variant is "${value.variant}" in HeaderBannerImageCard`
          )
          return false
        }

        return true
      },
    },
  },
})
</script>

<template>
  <HeaderBannerBaseCard
    :banner="banner"
    class="header-banner--image before:w-auto before:!left-[-110px]"
  />
</template>

<style lang="scss">
.header-banner.header-banner--image {
  .header-banner__content {
    @apply p-4 pb-3 w-fit;
  }

  .header-banner__text {
    @apply text-2xl leading-7 !important;
  }

  .header-banner__image {
    @apply flex-grow size-full;
  }

  .header-banner__trustpilot {
    @apply absolute bottom-2 left-1/2 -translate-x-1/2 justify-center items-center !w-full;

    .trustpilot-widget {
      @apply mx-2 bg-black rounded p-2 w-auto;
    }
  }
}
</style>
